import { createContext, useContext, useState, ReactNode, useCallback } from "react";

interface VerificationContextType {
  pendingCount: number;
  // Stub: Phase 06 will add a cross-cipher aggregate endpoint. The
  // VerificationManager (per-cipher) drives this directly via
  // `setPendingCount` from its WebSocket stream.
  setPendingCount: (count: number) => void;
  refreshPendingCount: () => Promise<void>;
}

const VerificationContext = createContext<VerificationContextType>({
  pendingCount: 0,
  setPendingCount: () => undefined,
  refreshPendingCount: async () => undefined,
});

export function VerificationProvider({ children }: { children: ReactNode }) {
  const [pendingCount, setPendingCount] = useState(0);

  const refreshPendingCount = useCallback(async () => {
    // Stream-driven elsewhere; nothing to do here yet. Phase 06 wires a
    // cross-cipher pending aggregate.
  }, []);

  return (
    <VerificationContext.Provider
      value={{ pendingCount, setPendingCount, refreshPendingCount }}
    >
      {children}
    </VerificationContext.Provider>
  );
}

export function useVerification() {
  return useContext(VerificationContext);
}
